module.exports = __webpack_public_path__ + "img/icon_roodie_costs.019bad68.svg";